module.exports = __webpack_public_path__ + "img/MOZ.d7263da4.svg";